import { Injector, ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { Config, ConfigInitializerService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CategoriesMenuStatePersistenceService } from './categories-menu-state-persistence.service';
import { CategoriesMenuStoreModule } from './store/categories-menu-store.module';

function statePersistenceFactory(injector: Injector): () => Observable<Config> {
  return () => {
    const catalogStatePersistenceService = injector.get(CategoriesMenuStatePersistenceService);
    const configInit = injector.get(ConfigInitializerService);

    return configInit.getStable('context').pipe(
      tap(() => {
        catalogStatePersistenceService.sync();
      }),
    );
  };
}

@NgModule({
  imports: [CategoriesMenuStoreModule],
})
export class MainCategoriesMenuDataAccessModule {
  static forRoot(): ModuleWithProviders<MainCategoriesMenuDataAccessModule> {
    return {
      ngModule: MainCategoriesMenuDataAccessModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = statePersistenceFactory(inject(Injector));

          return initializerFn();
        }),
      ],
    };
  }
}
